// extracted by mini-css-extract-plugin
export default {"heading":"LikOdS","harmony":"XA0wdi","left":"dyUMTR","right":"rFyn7G"};